import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "../context/LanguageContext";
import ReferenceCard from "./ReferenceCard";
import references from "../data/references";
import "./ReferencesSection.css";

const ReferencesSection = () => {
  const t = useT();

  return (
    <section
      aria-labelledby="references-title"
      className="references-section px-6 pb-12 pt-24 sm:pb-14"
    >
      <div className="mx-auto max-w-6xl">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-4 sm:mb-7">
          <div>
            <h2 id="references-title" className="brand-gradient-text text-3xl font-bold tracking-tight sm:text-4xl">
              {t("references.title")}
            </h2>
            <p className="mt-2 text-sm" style={{ color: "var(--muted)" }}>
              {t("references.description")}
            </p>
          </div>
          <Link to="/references" className="references-view-all">
            {t("references.viewAll")} <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>

        <Link
          to="/references"
          id="references-rail"
          className="references-rail"
          aria-label={t("references.viewAll")}
          style={{ "--references-duration": `${references.length * 6}s` }}
        >
          <div className="references-track">
            {[false, true].map((duplicate) => (
              <ul key={String(duplicate)} className="references-group" aria-hidden={duplicate || undefined}>
                {references.map((reference) => (
                  <li key={reference.name}>
                    <ReferenceCard {...reference} preview />
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </Link>
      </div>
    </section>
  );
};

export default ReferencesSection;
